import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  publishedList: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  logs: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  attrTypes: { data: [], loading: false },
  detail: { data: null, loading: false },
  existed: { data: null, loading: false },
  confirm: { title: '', content: '', name: '', data: null, visible: false, loading: false },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
